import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/about.css';

const values = [
  {
    icon: '✦',
    title: 'Claridad',
    description: 'Transformamos ideas complejas en soluciones simples y efectivas que tu equipo puede adoptar desde el primer día.',
    color: '#D8ECEB',
  },
  {
    icon: '◈',
    title: 'Confianza',
    description: 'Construimos relaciones duraderas basadas en transparencia, comunicación honesta y resultados medibles.',
    color: '#E7F58E',
  },
  {
    icon: '⬡',
    title: 'Innovación',
    description: 'Adoptamos las últimas tecnologías para mantener tu negocio a la vanguardia sin perder de vista lo que importa.',
    color: '#C6AEF5',
  },
];

const teamMembers = [
  {
    name: 'Tomás',
    role: 'Founder & CEO',
    description: 'Estratega digital y desarrollador con pasión por convertir problemas complejos en productos elegantes.',
  },
  {
    name: 'Ana',
    role: 'Graphic Designer',
    description: 'Diseñadora gráfica con experiencia en branding, web design y experiencia de usuario.',
  }
];

const stats = [
  { number: '+15', label: 'proyectos entregados' },
  { number: '100%', label: 'clientes satisfechos' },
  { number: '7+', label: 'años de experiencia' },
];

const About = ({ onNavigate }) => {

  const handleLinkClick = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    onNavigate(href);
  };

  return (
    <div className="about-page">

      <section className="about-hero">
        <p className="about-page-label">SOBRE NOSOTROS</p>
        <h1 className="about-hero-heading fredoka-400">
          Somos el equipo digital que tu negocio necesita.
        </h1>
        <p className="about-hero-sub">
          Estrategia, tecnología y diseño al servicio de tu crecimiento.
        </p>
      </section>

      <section className="about-who">
        <div className="about-who-inner">
          <div className="about-who-text">
            <p className="about-section-label">QUIÉNES SOMOS</p>
            <h2 className="about-who-heading fredoka-400">
              Nacimos para simplificar la tecnología.
            </h2>
            <p className="about-who-body">
              En Suko Solutions nos ponemos en el papel de nuestros clientes. Entendemos sus necesidades, sus procesos y sus objetivos para ofrecer soluciones digitales que realmente funcionen.
            </p>
            <p className="about-who-body">
              Trabajamos con emprendedores, pymes y empresas que quieren dar el salto digital sin complicaciones — facilitando, acelerando y automatizando sus flujos de trabajo.
            </p>
          </div>
          <div className="about-who-accent">
            {stats.map((stat, i) => (
              <div key={i} className="about-accent-card">
                <span className="about-accent-number">{stat.number}</span>
                <span className="about-accent-desc">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-values">
        <p className="about-page-label">NUESTROS VALORES</p>
        <h2 className="about-values-heading fredoka-400">Lo que nos define</h2>
        <div className="about-values-grid">
          {values.map((v, i) => (
            <div key={i} className="about-value-card" style={{ backgroundColor: v.color }}>
              <span className="about-value-icon">{v.icon}</span>
              <h3 className="about-value-title">{v.title}</h3>
              <p className="about-value-desc">{v.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="about-team">
        <p className="about-section-label">EL EQUIPO</p>
        <h2 className="about-team-heading fredoka-400">Las personas detrás de Suko Solutions</h2>
        <div className="about-team-grid">
          {teamMembers.map((member, i) => (
            <div key={i} className="about-team-card">
              <div className="about-team-avatar">{member.name[0]}</div>
              <h3 className="about-team-name">{member.name}</h3>
              <p className="about-team-role">{member.role}</p>
              <p className="about-team-desc">{member.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="about-cta">
        <h2 className="about-cta-heading fredoka-400">¿Trabajamos juntos?</h2>
        <p className="about-cta-sub">
          Cuéntanos tu idea y encontraremos la mejor forma de hacerla realidad.
        </p>
        <Link to="/contact" onClick={(e) => handleLinkClick(e)} className="about-cta-btn">Contáctanos</Link>
      </section>

    </div>
  );
};

export default About;
